<template>
    <div class="flex flex-col text-xs">
        <small class="uppercase">Starting From</small>
        <div class="flex items-center gap-2">
            <span
                v-if="pricing"
                class="text-gray-400 line-through"
                :class="size === 'list' ? 'text-base' : 'text-sm'"
            >
                {{ money(pricing.original) }}
            </span>
            <span
                class="text-primary"
                :class="
                    size === 'list'
                        ? 'text-2xl font-semibold'
                        : 'text-xl font-bold'
                "
            >
                {{ money(pricing ? pricing.price : tour.price) }}
            </span>
            <small class="text-xs">{{ tour.pricing_type }}</small>
            <i
                v-if="pricing?.terms"
                v-tooltip.top="pricing.terms"
                class="pi pi-info-circle cursor-help text-gray-400"
                style="font-size: 0.75rem"
            />
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import numeral from "numeral";
import { Tour } from "@/types";
import { promoPricing } from "@/utils/helpers";

const props = withDefaults(
    defineProps<{
        tour: Tour;
        size?: "grid" | "list";
    }>(),
    { size: "grid" },
);

const money = (value: number) => numeral(value).format("$0,0.00");

// Active promotion (discounted price + strikethrough + terms tooltip),
// shared with the tour detail page.
const pricing = computed(() => promoPricing(props.tour));
</script>
